import { Component, Inject, OnInit } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { BaseButtonSize } from '../../../../shared/components/button/base-button.component';
import { baseMatchValuesValidator } from '../../../../shared/validators/base-match-values.validator';
import { basePasswordValidator } from '../../../../shared/validators/base-password.validator';
import { baseAuthActions, BaseCoreState } from '../../../../_store';
import { BaseQueryParamService } from '../../../../shared/services/base-query-param.service';
import { ENVIRONMENTER } from '../../../../core/token/base-environmenter.token';

@Component({
  selector: 'base-reset-password',
  templateUrl: './base-reset-password.component.html',
})
export class BaseResetPasswordComponent implements OnInit {
  buttonSize = BaseButtonSize;
  submitted = false;
  resetForm = this.fb.group({
    password: ['', [Validators.required, basePasswordValidator()]],
    repeatPassword: ['', [Validators.required, baseMatchValuesValidator('password')]],
  });
  appLogoSrc = '';
  isCustomizedUser = false;

  constructor(
    @Inject(ENVIRONMENTER) private environment: any,
    private queryParamsService: BaseQueryParamService,
    private activatedRoute: ActivatedRoute,
    private store: Store<BaseCoreState>,
    private fb: NonNullableFormBuilder
  ) {}

  ngOnInit() {
    this.authenticateUser();
    this.setAppLogo();
  }

  submit(): void {
    this.submitted = true;
    this.resetForm.markAllAsTouched();
    if (this.resetForm.valid) {
      this.store.dispatch(
        baseAuthActions.resetPasswordConfirmation({
          payload: {
            body: this.resetForm.getRawValue(),
            token: this.activatedRoute.snapshot.params.token,
          },
        })
      );
      this.submitted = false;
    }
  }

  cancel(): void {
    this.store.dispatch(baseAuthActions.navigateToLoginPage({}));
  }

  setAppLogo(): void {
    this.appLogoSrc = this.isCustomizedUser
      ? 'assets-global/images/e-masters/business-logo-regular.svg'
      : this.environment.application.logo;
  }

  private authenticateUser(): void {
    const customizedUserUrlParam = this.queryParamsService.getQueryParamByName('network');

    if (customizedUserUrlParam) {
      this.isCustomizedUser = true;
      this.store.dispatch(baseAuthActions.setCustomizedUser({ payload: true }));
    }
  }
}
